import { Link } from 'react-router-dom';
import { newMovies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function LatestMovies() {
  return (
    <section className="py-8 md:py-10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <div className="w-1 h-5 rounded-full bg-accent-500" />
            <h2 className="text-lg md:text-xl font-heading text-foreground-950">最新更新</h2>
            <span className="px-2 py-0.5 rounded-full bg-primary-500/15 text-primary-500 text-xs font-medium whitespace-nowrap">
              本周新增
            </span>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-3">
          {newMovies.map(movie => (
            <MovieCard key={movie.id} movie={movie} size="normal" />
          ))}
          {newMovies.length === 0 && (
            <div className="flex-1 flex items-center justify-center py-12">
              <p className="text-foreground-500 text-sm">暂无最新电影</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}